import baseUrl from '@/assets/js/baseUrl.js';
import http from './http'

export var companyOrg = {
  // 获取部门管理列表
  getOrgList(params) {
    return http.post(`${baseUrl}Org/list`, params)
  },
  // 编辑/新增组织成员
  addOrEdit(params) {
    return http.post(`${baseUrl}Org/addOrEdit`, params)
  },
  // 删除组织成员
  delOrg(params) {
    return http.post(`${baseUrl}Org/del`, params)
  },
  // 获取审核人列表
  getOrgUserList(params) {
    return http.post(`${baseUrl}User/userList`, params)
  },
}



// WEBPACK FOOTER //
// ./src/api/companyOrg.js